export enum EPasswordField {
  PASSWORD_RESET_CONTAINER = "PASSWORD_RESET_CONTAINER",
  PASSWORD_VALIDATION_BOX = "PASSWORD_VALIDATION_BOX",
  PASSWORD_STRENGTH_INDICATOR = "PASSWORD_STRENGTH_INDICATOR",
  HINT_ELEMENT = "HINT_ELEMENT",
  HINT_TEXT = "HINT_TEXT",
  HINT_STRENGTH = "HINT_STRENGTH",
  STEP_ELEMENT = "STEP_ELEMENT",
  NEW_PASSWORD = "NEW_PASSWORD",
  CONFIRM_PASSWORD = "CONFIRM_PASSWORD",
  ERROR_LIST_ELEMENTS = "ERROR_LIST_ELEMENTS",
  PASSWORD_SHOW_HIDE_ELEMENTS = "PASSWORD_SHOW_HIDE_ELEMENTS",
}
